import React from 'react';

import { Value, ValueTypeConfig } from './Content.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function Text(props) {
    let blockProps = {};
    if (props.config && props.config.config && props.config.config.Block) {
        blockProps = props.config.config.Block;
    }
    return <Value {...props} value={blockProps.design} />;
}
const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    _TypeConfig.options.firstPageOnly(group),
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: Utilities.wrapTextForEditor({ text: 'Text' })
                    }
                ]
            };
        },
        style: () => ValueTypeConfig.panel.style('style')
    }
};

export {
    Text as Component,
    TypeConfig
};